
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';

const loadingFallback = (<div />);
const errorFallback = () => (<Redirect to="campaign/vnext" />);

const withCurrentAdGroup = (WrappedComponent, enableErrorFallback = true) => {
  const Wrapper = props => (
    <CampaignOData
      call={({ currentAdGroup }) => currentAdGroup.get()}
      escapeHatch={({ currentAdGroup }) => (currentAdGroup ? undefined : null)}
      fallback={loadingFallback}
      onError={enableErrorFallback
        ? errorFallback
        : () => (<WrappedComponent {...props} currentAdGroup={null} />)}
    >
      {currentAdGroup =>
            (<WrappedComponent {...props} currentAdGroup={currentAdGroup} />)}
    </CampaignOData>
  );

  Wrapper.displayName = `withCurrentAdGroup(
      ${getDisplayName(WrappedComponent)}
    )`;

  hoistNonReactStatics(Wrapper, WrappedComponent);

  Wrapper.propTypes = {
    scope: PropTypes.instanceOf(QueryParam).isRequired,
  };

  return Wrapper;
};

const withCurrentCampaign = (WrappedComponent, enableErrorFallback = true) => {
  const Wrapper = props => (
    <CampaignOData
      call={({ currentCampaign }) => currentCampaign.get()}
      escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : null)}
      fallback={loadingFallback}
      onError={enableErrorFallback
        ? errorFallback
        : () => (<WrappedComponent {...props} currentCampaign={null} />)}
    >
      { currentCampaign =>
            (<WrappedComponent {...props} currentCampaign={currentCampaign} />) }
    </CampaignOData>
  );

  Wrapper.displayName = `withCurrentCampaign(
      ${getDisplayName(WrappedComponent)}
    )`;

  hoistNonReactStatics(Wrapper, WrappedComponent);

  Wrapper.propTypes = {
    scope: PropTypes.instanceOf(QueryParam).isRequired,
  };

  return Wrapper;
};

export const withCurrentExpandedScope =
 component => withScope(withCurrentAdGroup(withCurrentCampaign(component)));

export const withCurrentExpandedScopeNoFallback =
 component => withScope(withCurrentAdGroup(withCurrentCampaign(component, false), false));
